interface IIsAllowedPrev {
  editMode: boolean;
  currentPageIndex: number;
  ROUTES_TO_AVOID_BACK: string[];
  pathname: string;
  forceShowBack?: boolean;
}

export const isAllowedPrev = ({
  editMode,
  currentPageIndex,
  pathname,
  ROUTES_TO_AVOID_BACK,
  forceShowBack = false,
}: IIsAllowedPrev): boolean => {
  if (forceShowBack) return true;
  if (editMode) return false;
  if (currentPageIndex === 0) return false;
  if (ROUTES_TO_AVOID_BACK.includes(pathname)) return false;
  return true;
};
